import { useLocation } from "react-router-dom";
import { useState } from "react";
import { Row } from "react-bootstrap";
import SelectRange from "../components/selectProductRange_component/SelectRange";
import NextButton from "../components/selectProductRange_component/NextButton";
import "../common/CommonStyle.css";
import SelectProductRangeDescription from "../components/selectProductRange_component/SelectProductRangeDescription";

export default function SelectProductRange() {
  const location = useLocation();
  const productRangeState = location.state?.productRangeState;
  const [selectedProductRange, setSelectedProductRange] = useState<
    string | null
  >(null);

  return (
    <>
      <Row>
        <h4>Select Product Range</h4>
      </Row>
      <SelectProductRangeDescription
        selectedProductRange={selectedProductRange}
        productRangeState={productRangeState}
      />
      <SelectRange
        productRangeState={productRangeState}
        onSelect={(productRange) => {
          setSelectedProductRange(productRange);
        }}
      />
      <NextButton
        productRangeState={productRangeState}
        selectedProductRange={selectedProductRange}
      />
    </>
  );
}
